module.exports = __webpack_public_path__ + "static/media/drexellogo.ca90cf59.jpg";